<template>
    <div class="app-container">
      <el-row class="headTop">
        <!-- <el-col :span="4">
          团课编码：<el-input
            style="width:200px"
            placeholder="请输入团课编码"
            v-model="params.code"
            clearable>
          </el-input>
        </el-col> -->
        <el-col :span="22">
          名称：<el-input
            class="w150"
            placeholder="请输入团课名"
            v-model="params.name"
            clearable>
          </el-input>
          <el-button class="ml20" style="width:100px"   type="primary" icon="el-icon-search"  @click="queryList()">查询</el-button>
        </el-col>
        <el-col :span="2">
          <el-button style="width:100%"   type="success" icon="el-icon-circle-plus-outline" @click="showDialog()">新增</el-button>
        </el-col>
      </el-row>
    <el-dialog title="团课类型信息"  :visible.sync="dialogVisible" width="1000px">
        <el-form :model="formparams" :rules="rules" ref="formparams" label-width="120px">
          <el-form-item label="团课类型名称" prop="name">
            <el-input class="w220" v-model="formparams.name" placeholder="请输入团课类型名称" maxlength="20"></el-input>
          </el-form-item>
          <!-- <el-form-item label="团课类型编号" prop="code">
            <el-input class="w220" v-model="formparams.code" placeholder="团课类型编号" maxlength="20"></el-input>
          </el-form-item> -->
          <el-form-item label="团课类型说明" prop="remark">
            <el-input type="textarea" rows="4"  v-model="formparams.remark" placeholder="请输入团课类型说明"></el-input>
          </el-form-item>
          <el-form-item label="分店" prop="shopNum">
            <el-select v-model="formparams.shopNum" placeholder="请选择">
                <el-option
                v-for="item in this.shopList"
                :key="item.shopNum"
                :label="item.name"
                :value="item.shopNum"
                ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button style="width:100px"  @click="resetForm('formparams')">取 消</el-button>
            <el-button style="width:100px"  type="primary" @click="submitForm('formparams')">确 定</el-button>
        </span>
    </el-dialog>
    <el-row class="tableList">
      <el-table v-loading="loading" :data="tableData" height="73vh" border stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <!-- <el-table-column prop="code" label="团课类型编码"></el-table-column> -->
        <el-table-column prop="name" label="团课类型名称"></el-table-column>
        <el-table-column prop="remark" label="团课类型说明"></el-table-column>
        <el-table-column label="分店">
          <template slot-scope="scope">
            <div> {{scope.row.shopnum|caseType}} </div>
          </template>
          
        </el-table-column>
        <el-table-column width="300" label="操作">
          <template slot-scope="scope">
            <el-button style="width:100px"  type="primary" @click="edit(scope.row)">编辑</el-button>
            <!-- <el-button style="width:100px"  type="danger" @click="removeList(scope.row.id)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pageination" style="display:none">
      <el-col>
        <el-pagination
          style="textAlign:center;marginTop:10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 40, 80, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.total"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
let that;
import {getTbCourseType, insertTbCourseType, getShops, updateTbCourseType } from "../../api/configApi";
import mainHead from "../../components/mainHead/mainHead";
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      date:[],//开始时间结束时间
      rules:{
        name:[
          { required: true, message: '请输入团课类型名称', trigger: 'blur' }
        ],
        code:[
          { required: true, message: '请输入code', trigger: 'blur' },
          { pattern:/^\d/, message: '请输入正确的code', trigger: 'blur' }
        ],
        shopNum:[{ required: true, message: '请选择分店', trigger: 'blur' }],
        remark:[{ required:true,message:'请输入团课类型说明',trigger:'blur' }]
      },
      timeList:[],
      addType:1,
      formparams:{
          name:'',
          code:'',
          shopNum:'',
          remark:'',
      },
      formData:{},
      fileList:[],
      //票列表
      tableData:[],
      //票类型
      options:[],
      titleList:[],
      //分店列表
      shopList:[],
      shopListAll:JSON.parse(sessionStorage.getItem('shopListAll')),
      total: 0,
      currentPage: 1,
      params: {
        code:null,
        name:null,
        // page: 1,
        // size: 20
      }
    }
  },
  filters:{
    caseType(value) {
      if (that.shopListAll.find(i => {
        return i.shopNum == value
        })) {
        return that.shopListAll.find(i => {
            return i.shopNum == value
        }).name
      }
    }
  },
  components: {
    mainHead
  },
  beforeCreate(){
    that = this;
  },
  created(){
    // this.getShopsList()
  },
  mounted() {
    if(sessionStorage.getItem('shopList')){
      this.shopList = JSON.parse(sessionStorage.getItem('shopList'))
      for (let i = 0; i < this.shopList.length; i++) {
        this.titleList.push({value:this.shopList[i].shopNum,text:this.shopList[i].name})
      }
      if(JSON.parse(sessionStorage.getItem('userinfo')).shopNum!=null){
        this.params.shopNum = this.shopList[0].shopNum
        this.showShop = false
      }else{
        this.showShop = true
      }
    } else{
      this.getShopsList()
    }
    this.getTableList()
  },
  methods: {
    showDialog(){
        this.dialogVisible =true
        this.addType = 1
        this.formparams.name=''
        this.formparams.code=''
        this.formparams.shopNum=''
        this.formparams.remark=''
    },
    queryList(){
      this.getTableList()
    },
    //查询团课类型列表
    getTableList(){
      getTbCourseType(this.params).then((res)=>{
        if(res.msg == "success"){
            this.tableData = res.data
        }
      })
    },
    //查询分店类型
    getShopsList(){
       getShops({isWeb:1}).then((res)=>{
        this.shopList = res.data
        sessionStorage.setItem('shopList',JSON.stringify(res.data))
        if(JSON.parse(sessionStorage.getItem('userinfo')).shopNum!=null){
          this.queryParams.shopNum = this.shopList[0].shopNum
          this.showShop = false
        } else {
          this.queryParams.shopNum = ''
          this.showShop = true
        }
      })
    },
    //编辑
    edit(row){
      this.addType = 2
      this.dialogVisible = true
      this.formparams.id = row.id
      this.formparams.name=row.name
      this.formparams.code=row.code
      this.formparams.shopNum=row.shopnum
      this.formparams.remark=row.remark
    },
    //添加票
    // insertOnlineTicketInfo
    submitForm(formparams){
      this.$refs[formparams].validate(valid => {
        if (valid) {
          if(this.addType == 1){
            // for (let i = 0; i < this.tableData.length; i++) {
            //   if(this.formparams.code === this.tableData[i].code){
            //     this.$message.error('输入的code不能重复')
            //     return
            //   }
            // }
            this.formparams.code = null
            insertTbCourseType(this.formparams).then((res)=>{
              console.log(res)
              if(res.msg=="success"){
                this.$message({
                  type:'success',
                  message:'添加成功'
                })
              } else{
                this.$message.error(res.data)
              }
              this.dialogVisible = false
              this.getTableList()
            })
          } else {
            updateTbCourseType(this.formparams).then((res)=>{
              if(res.msg=="success"){
                this.$message({
                  type:'success',
                  message:'修改成功'
                })
              } else{
                this.$message.error(res.data)
              }
              this.dialogVisible = false
              this.getTableList()
            })
          }
          
        } else {
          this.$message.error('请检查必填项');
          return false;
        }
      });
    },
    //取消
    resetForm(formparams) {
      this.dialogVisible = false;
      this.$refs[formparams].clearValidate();
    },
      //分页
    handleSizeChange(val) {
      this.params.size = val;
      this.params.page = 1;
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.params.page = val;
    },
  }
};
</script>
<style lang="scss">

</style>


// WEBPACK FOOTER //
// classType.vue?0e6599ea